module.exports = __webpack_public_path__ + "media/images/community__tease__deco--mobile-a2f3cf00bffc86d2726b58925a61a885.png";